import { render } from "./players-reports.vue?vue&type=template&id=1bd6b768&ts=true"
import script from "./players-report.ts?vue&type=script&lang=ts"
export * from "./players-report.ts?vue&type=script&lang=ts"

import "./players-report.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__